export const reservedCharactersAlias = {
  forwardSlash: 's1L2a3S4h',
  plus: 'p1L2u3S',
  equal: 'e1Q2u3A4l',
} as const;
